import { Component } from '@verndale/core';

class TableCardContainer extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el,
      statsCard: this.el.querySelectorAll<HTMLElement>('.table-card-container__card--stats-card')
    };

    this.initModule();
  }

  initModule() {
    if ((this.dom.statsCard as NodeList).length < 3) {
      this.el.classList.add('table-card-container__no-border');
    }
  }
}

export default TableCardContainer;
